<template>
  <div class="bg-gray-800 rounded-t-none rounded-lg pb-2">
    <ul class="bg-gray-800 select-none">
      <li class="w-full flex items-center pb-4">
        <div class="w-1/2 py-4 bg-gray-700 text-center border-r-2 border-gray-800">
          <input
            v-model="minutes"
            class="w-6 bg-gray-700 text-white focus:outline-none placeholder-gray-600"
            type="text"
          />mn
        </div>
        <div class="w-1/2 py-4 pl-1 bg-gray-700 text-center">
          <input
            v-model="seconds"
            class="w-6 bg-gray-700 text-white focus:outline-none placeholder-gray-600"
            type="text"
          />sec
        </div>
      </li>
      <li
        class="py-3 px-2 bg-gray-700 cursor-pointer"
        @click="
          setTimer({ minutes, seconds })
          $emit('closeMenu')
        "
      >
        Durée pour cette question
      </li>
      <li
        class="py-3 px-2 bg-gray-800 cursor-pointer"
        @click="
          setTimer({ minutes, seconds, isTimerForAllQuestions: false })
          $emit('closeMenu')
        "
      >
        Durée pour toutes les questions suivantes
      </li>
      <li
        class="py-3 px-2 bg-gray-700 cursor-pointer"
        @click="
          setTimer({ minutes, seconds, isTimerForAllQuestions: true })
          $emit('closeMenu')
        "
      >
        Durée pour toutes les questions
      </li>
    </ul>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"

export default {
  data() {
    return {
      minutes: 0,
      seconds: 0,
    }
  },
  computed: {
    ...mapState({
      timer: (state) => state.live.timer,
    }),
  },
  methods: {
    ...mapMutations("live", ["setTimer"]),
  },
  mounted() {
    this.minutes = Math.floor(this.timer / 60)
    this.seconds = this.timer % 60
  },
}
</script>

<style></style>
